import React, { useEffect, useRef, useState } from 'react'

import axios from 'axios'

import './_taxDocument.scss'
import { Form, Formik, useField } from 'formik'
import { zip } from 'lodash'
import { useQuery } from 'react-query'
import styled from 'styled-components'

import { Button } from 'components/Button/Button'
import { FormikSelect } from 'components/Form/FormikSelect/FormikSelect'
import InlineDatePicker from 'components/UI/InlineDatePicker/InlineDatePicker'
import DateModal from 'components/UI/Modal/Date/DateModal'
import ScheduleBubble from 'components/UI/Modal/ScheduleContent/Components/ScheduleBubble'
import { useModalContext } from 'context/modalContext'
import { getCountries } from 'services/endpoints/country'
import { blockUser } from 'services/endpoints/report'
import colors from 'styles/colors'
import { type Country } from 'types/api/country'
import { addToast } from 'components/Toast/Toast'
import { dac7, getDac7taxform } from './taxformapi'


// Define the FormData interface
interface FormData {
    idIssuingCountry: string
    idIssuingCountryCode: string
    residenceCountry: string
    residenceCountryCode: string
    birthCountry: string
    birthCountryCode: string
    cityofbirth: string
    taxIdentificationnumber: string
    vatNumber: string
    confirmPayouts: boolean
}

function W9() {
    const [formData, setFormData] = useState<FormData>({
        idIssuingCountry: '',
        idIssuingCountryCode: '',
        residenceCountry: '',
        residenceCountryCode: '',
        birthCountry: '',
        birthCountryCode: '',
        cityofbirth: '',
        taxIdentificationnumber: '',
        vatNumber: '',
        confirmPayouts: false
    })


    const [idIssuingCountry, setIdIssuingCountry] = useState<any | null>(null)
    const [residenceCountry, setResidenceCountry] = useState<any | null>(null)
    const [birthCountry, setBirthCountry] = useState<any | null>(null)



    const [selectedCountry, setSelectedCountry] = useState<any | null>(null)
    console.log(selectedCountry, 'selectedCountry')
    // console.log('W9 Form Loaded', formData) //  Debugging log
    const { data: beneficiaryCountries } = useQuery(
        'allCountries',
        getCountries,
        {
            refetchOnWindowFocus: false,
            select(data) {
                return data.map((country: Country) => ({
                    value: country.code,
                    label: country.name,
                    regions: country.regions,
                    data: country
                }))
            }
        }
    )
    // console.log(beneficiaryCountries, 'beneficiaryCountries');
   
    useEffect(() => {
        const fetchData = async () => {
          const response = await getDac7taxform();
          const success = response?.success ?? false;
          const taxData = response?.data?.data || {};
          if (success && beneficiaryCountries?.length) {
            const idIssuingCountryCode = beneficiaryCountries.find(
              (country: any) => country.value === taxData?.idIssuingCountryCode
            );
            const residenceCountryCode = beneficiaryCountries.find(
                (country: any) => country.value === taxData?.residenceCountryCode
              );
              const birthCountryCode = beneficiaryCountries.find(
                (country: any) => country.value === taxData?.birthCountryCode
              );
            setIdIssuingCountry(idIssuingCountryCode);
            setResidenceCountry(residenceCountryCode);
            setBirthCountry(birthCountryCode);
            setFormData(taxData);
          } else {
            console.log(' W-8BEN Form Fetch Error or beneficiaryCountries not loaded');
          }
        };
        if (beneficiaryCountries?.length) {
            fetchData();
          }
        }, [beneficiaryCountries]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target

        // Handle checkbox separately
        if (type === 'checkbox') {
            setFormData(prev => ({
                ...prev,
                [name]: checked
            }))
            return
        }

        // Handle all other text fields (allow any string input)
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handleSubmit = async () => {
        const payload = {
            idIssuingCountry: formData.idIssuingCountry,
            idIssuingCountryCode: formData.idIssuingCountryCode,
            residenceCountry: formData.residenceCountry,
            residenceCountryCode: formData.residenceCountryCode,
            birthCountry: formData.birthCountry,
            birthCountryCode: formData.birthCountryCode,
            cityofbirth: formData.cityofbirth,
            taxIdentificationnumber: formData.taxIdentificationnumber,
            vatNumber: formData.vatNumber,
            confirmPayouts: formData.confirmPayouts
        }

        try {
            const result = await dac7(payload);

            if (result.status === 'OK') {
                addToast('success', 'Form Submitted Successfully')
            }
            
        } catch (error) {
            console.error('Error submitting W9 form:', error)
        }
    }

    return (
         <div className='tax-document'>
        <div className='mb-5'>
            <div className='form-header'>
                <h2>Provide the information in the form below</h2>
            </div>

            <div className='fatca-note-section'>
                <p>
                    performer platform will use data provided by you in your application to
                    comply with DAC7 reporting. Some information was not
                    collected during the application stage and has to be
                    provided to continue receiving payouts.
                </p>
                <p>
                    At any time, you can submit new DAC7 information if you
                    believe you have made a mistake. If information in your
                    application is wrong, please contact support.{' '}
                </p>

                <hr className='separator' />
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit}>
                <div className='mb-6'>
                    <div className=''>
                        <Formik initialValues={{
                            idIssuingCountry: '',
                        }} onSubmit={() => { }}>
                            {({ setFieldValue }) => (
                                <Form className=''>
                                    <InputLabel
                                        $filled={true}
                                        htmlFor={'Id issuing country'}
                                    >
                                        {'ID Issuing Country '}
                                    </InputLabel>
                                    <FormikSelect
                                        fieldName='idIssuingCountryCode'
                                        label='Please Select a Country'
                                        options={beneficiaryCountries}
                                        selectedValue={idIssuingCountry?.value ?? ''}
                                        onChange={selected => {
                                            setFieldValue('idIssuingCountryCode',  selected.value);
                                            setFieldValue('id_issuing_country', selected.label);
                                            setIdIssuingCountry(selected)
                                            setFormData(prev => ({
                                                ...prev,
                                                idIssuingCountry: selected.label,
                                                idIssuingCountryCode: selected.value
                                            }))
                                        }}
                                        onTouched={() => { }}
                                    />
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>

                <div className='mb-6'>
                    <div className=''>
                        <Formik initialValues={{}} onSubmit={() => { }}>
                            {({ setFieldValue }) => (
                                <Form className=''>
                                    <InputLabel
                                        $filled={true}
                                        htmlFor={'Country Of Residence'}
                                    >
                                        {'Country Of Residence'}
                                    </InputLabel>
                                     
                                    <FormikSelect
                                        fieldName='residenceCountryCode'
                                        label='Please Select a Country'
                                        options={beneficiaryCountries}
                                        selectedValue={residenceCountry?.value ?? ''}
                                        onChange={selected => {
                                            setFieldValue('residenceCountryCodee', selected.value);
                                            setFieldValue('residence_country', selected.label);
                                            setResidenceCountry(selected)
                                            setFormData(prev => ({
                                                ...prev,
                                                residenceCountry: selected.label,
                                                residenceCountryCode: selected.value
                                            }))
                                        }}
                                        onTouched={() => { }}
                                    />


                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>

                <div className='mb-6'>
                    <div className=''>
                        <Formik initialValues={{}} onSubmit={() => { }}>
                            {({ setFieldValue }) => (
                                <Form className=''>
                                    <InputLabel
                                        $filled={true}
                                        htmlFor={'Country Of Birth'}
                                    >
                                        {'Country Of Birth '}
                                    </InputLabel>
                                    <FormikSelect
                                        fieldName='birthCountryCode'
                                        label='Please Select a Country'
                                        options={beneficiaryCountries}
                                        selectedValue={birthCountry?.value ?? ''}
                                        onChange={selected => {
                                            setFieldValue('birthCountryCode',  selected.value);
                                            setFieldValue('birth_country', selected.label);
                                            setBirthCountry(selected)
                                            setFormData(prev => ({
                                                ...prev,
                                                birthCountry: selected.label,
                                                birthCountryCode: selected.value
                                            }))
                                        }}
                                        onTouched={() => { }}
                                    />

                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>

                <div className='mb-6'>
                    <InputContainer>
                        <InputLabel $filled={true} htmlFor={'city of birth'}>
                            {'City of Birth '}
                        </InputLabel>
                        <Input
                            id={'cityofbirth'}
                            name='cityofbirth'
                            type='text'
                            $filled={true}
                            value={formData.cityofbirth}
                            onChange={handleChange}
                        />
                        {/* {meta.touched && meta.error ? ( */}
                        <ErrorMessageComponent>{''}</ErrorMessageComponent>
                    </InputContainer>

                    <div className='mt-4'>
                        <InputContainer>
                            <InputLabel
                                $filled={true}
                                htmlFor={'taxIdentificationnumber'}
                            >
                                {'Tax Identification Number '}
                            </InputLabel>
                            <Input
                                id={'taxIdentificationnumber'}
                                name='taxIdentificationnumber'
                                type='number'
                                $filled={true}
                                value={formData.taxIdentificationnumber}
                                onChange={handleChange}
                            />
                        </InputContainer>
                    </div>
                    <div className='mt-4'>
                        <InputContainer>
                            <InputLabel $filled={true} htmlFor={'vatNumber'}>
                                {'VAT Number (optional)'}
                            </InputLabel>
                            <Input
                                id={'vatNumber'}
                                name='vatNumber'
                                type='number'
                                $filled={true}
                                value={formData.vatNumber}
                                onChange={handleChange}
                            />
                        </InputContainer>
                    </div>
                </div>

                <div className='mb-6'>
                    <input
                        type='checkbox'
                        name='confirmPayouts'
                        checked={formData.confirmPayouts}
                        onChange={handleChange}
                        style={{ marginTop: '4px' }}
                    />
                    <span>
                        I confirm the accuracy of the payouts visible here. If
                        you believe they do not accurately reflect your earnings
                        from performer platform, please contact support at{' '}
                        <a href='mailto:xyz@xyz.com'>
                            xyz@xyz.com
                        </a>
                        .
                    </span>
                </div>

                <Button
                    text='Submit'
                    color='blue'
                    font='mont-14-normal'
                    width='13'
                    customClass={'m-auto'}
                    height='4'
                    clickFn={() => {
                        handleSubmit()
                    }}
                />
            </form>
        </div>
        </div>
    )
}

export default W9

interface InputProps {
    $filled: boolean
}

const InputContainer = styled.div`
    position: relative;
    display: block;
    align-items: center;
    height: auto;
    background: ${colors.white89deg};
    box-sizing: border-box;
    box-shadow: ${colors.shadowBlack};
    border-radius: 2rem;
    margin: 1rem 0;
`

const InputLabel = styled.label<InputProps>`
    font-weight: 800;
    letter-spacing: 0.02em;
    font-size: 1.2rem;
    line-height: 1.5rem;
    font-weight: 500;
    color: #6d6d6d;
    pointer-events: none;
    transition: 0.2s all;
    transform: translateY(0);
    margin-bottom: 0.5rem;
    display: block;
`

const Input = styled.input<InputProps>`
    font-weight: 600;
    letter-spacing: 0.02em;
    font-size: 1.4rem;
    line-height: 1.7rem;
    text-indent: 1.8rem;
    height: 36px;
    width: 100%;
    border-radius: 2rem;
    border: 0.1rem solid #dddddd;
    transition:
        border 0.2s,
        padding 0.2s;
`

const ErrorMessageComponent = styled.div`
    position: absolute;
    right: 0;
    font-weight: 500;
    letter-spacing: 0.02em;
    font-size: 1.2rem;
    line-height: 1.5rem;
    color: ${colors.red};
    margin-right: 2rem;
`
